import {
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
} from '@mui/material';
import { CustomUser } from 'api/models/CustomUser';
import { useZoom } from 'context/ZoomContext';
import { modelFiltersStyles } from '../Filters/ModelFilters.styles';
import { UserAutocomplete } from '../Filters/UserAutocomplete';

interface UserGroupFormProps {
  name: string;
  onNameChange: (value: string) => void;
  selectedUsers: CustomUser[];
  onUsersChange: (users: CustomUser[]) => void;
  userSearchInput: string;
  onUserSearchInputChange: (value: string) => void;
  isDefault: boolean;
  onIsDefaultChange: (value: boolean) => void;
  staffUsers: CustomUser[];
  isLoadingStaff: boolean;
}

export const UserGroupForm = ({
  name,
  onNameChange,
  selectedUsers,
  onUsersChange,
  userSearchInput,
  onUserSearchInputChange,
  isDefault,
  onIsDefaultChange,
  staffUsers,
  isLoadingStaff,
}: UserGroupFormProps) => {
  const { zoomLevel } = useZoom();

  return (
    <Box display="flex" flexDirection="column" gap={2} pt={1}>
      <TextField
        label="Group name"
        value={name}
        onChange={e => onNameChange(e.target.value)}
        size="small"
        fullWidth
        autoFocus
      />
      <UserAutocomplete
        options={staffUsers}
        value={selectedUsers}
        onChange={(_e, newValue) => onUsersChange(newValue)}
        onInputChange={(_e, v) => onUserSearchInputChange(v)}
        inputValue={userSearchInput}
        loading={isLoadingStaff}
        label="Users"
        placeholder="Search users..."
        zoomLevel={zoomLevel}
        textFieldSx={{
          ...modelFiltersStyles.autocompleteTextField,
          '& .MuiInputBase-root': {
            minHeight: '40px',
            height: 'auto',
            flexWrap: 'wrap',
          },
        }}
        maxVisibleTags={6}
        showFullNames
      />
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            checked={isDefault}
            onChange={e => onIsDefaultChange(e.target.checked)}
          />
        }
        label="Set as default group"
        sx={{ width: 'fit-content' }}
      />
    </Box>
  );
};
